export default __webpack_public_path__ + "img/update.9f31e881.png";